<template>
    <div class="container mt-4 mb-20">
        <div class="row">
            <div class="col-12 col-md-12">
                <div class="cryptocurrency-data-table table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="text-left">Name</th>
                                <th class="text-center p-2">Reporting Period</th>
                                <th class="text-center p-2">All in Cost</th>
                                <th class="text-center p-2">Hist Cash Flows</th>
                                <th class="text-center p-2">Proj Cash Flows</th>
                                <th class="text-center p-2">Total Cash Flows</th>
                                <th class="text-center p-2">Disposition Date</th>
                                <th class="text-center p-2">Profit</th>
                                <th class="text-center p-2">IRR</th>
                                <th class="text-center p-2">Gross Multiple</th>
                                <th class="text-center p-2">Wtd Avg Life (yrs)</th>
                                <th class="text-center p-2">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <TableRowVue tokenName="A&E TOKEN 1" rowColor="bg-gray-200" />
                            <TableRowVue tokenName="A&E TOKEN 2" rowColor="bg-white" />
                            <TableRowVue tokenName="A&E TOKEN 3" rowColor="bg-gray-200" />
                            <TableRowVue tokenName="A&E TOKEN 4" rowColor="bg-white" />
                            <TableRowVue tokenName="A&E TOKEN 5" rowColor="bg-gray-200" />
                            <TableRowVue tokenName="A&E TOKEN 6" rowColor="bg-white" />
                            <TableRowVue tokenName="A&E TOKEN 7" rowColor="bg-gray-200" />
                            <TableRowVue tokenName="BlackStone 1" rowColor="bg-white" />
                            <TableRowVue tokenName="BlackStone 2" rowColor="bg-gray-200" />
                            <TableRowVue tokenName="BlackStone 3" rowColor="bg-white" />
                            <TableRowVue tokenName="BlackStone 4" rowColor="bg-gray-200" />
                            <TableRowVue tokenName="BlackStone5" rowColor="bg-white" />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TableRowVue from './TableRow';

export default {
    name: 'Table',
    components: {
        TableRowVue
    }
}
</script>